"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'slot.goal.efficiency': '效率',
    'slot.goal.accuracy': '准确性',
    'slot.goal.creativity': '创造性',
    'slot.goal.detail': '详细',
};
